import { render, staticRenderFns } from "./TaxRates.vue?vue&type=template&id=1296dd74"
import script from "./TaxRates.vue?vue&type=script&lang=js"
export * from "./TaxRates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports